module.exports = __webpack_public_path__ + "img/french-pearl.a77da163.jpg";